module.exports = __webpack_public_path__ + "img/ai-compare-history-open-in-new.75727864.svg";